import { Icon } from '@/components/common';
import Icons from '@/const/icons';
import { ClientSegmentType } from '@/interfaces';
import { getSegmentClientColor } from '@/lib';
import clsx from 'clsx';

interface SegmentClientProps {
	label: ClientSegmentType;
	className?: string;
	withTextColor?: boolean;
	classNameLabel?: string;
	cutCustomer?: boolean;
}

export const SegmentClient: React.FC<SegmentClientProps> = ({
	label,
	className,
	withTextColor,
	classNameLabel,
	cutCustomer = false,
}) => {
	return (
		<div
			className={clsx('flex items-center gap-x-2 w-full min-w-0', className)}
		>
			<Icon
				src={Icons.profile}
				width={14}
				height={14}
				className={`flex-shrink-0 !text-[${getSegmentClientColor(label)}]`}
			/>
			<p
				className={clsx(
					'font-semibold text-xs truncate min-w-0',
					classNameLabel,
					withTextColor
						? `!text-[${getSegmentClientColor(label)}]`
						: 'text-black'
				)}
			>
				{cutCustomer ? label.replace('Customer', '') : label}
			</p>
		</div>
	);
};
